import React, { Component } from "react";

export default class Decorations extends Component {
  render() {
    return (
      <div>
        <div className="first-child">
          {/* <button
              name="scroll-right"
              className="m-0 button-shadow-right scroll"
              onClick={() => {
                this.handleManualScroll("right");
              }}
            >
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 240.823 240.823"
                enableBackground="new 0 0 240.823 240.823"
              >
                <g>
                  <path
                    id="Chevron_Right_1_"
                    d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179
                                        l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261
                                        C187.881,124.315,187.881,116.495,183.189,111.816z"
                  />
                </g>
              </svg>
            </button> */}
          <ul>
            {Object.keys(this.props.decorations).map((decorationKey, i) => (
              <li
                className={
                  this.props.activeDecorationType === decorationKey
                    ? "active"
                    : ""
                }
                id={decorationKey}
                onClick={this.props.activeDecorationTypeHandler}
                key={decorationKey + i}
              >
                {" "}
                {decorationKey}{" "}
              </li>
            ))}
          </ul>
          {/* <button
              name="scroll-left"
              className="m-0 button-shadow-left scroll"
              onClick={() => {
                this.handleManualScroll("left");
              }}
            >
              <svg
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 240.823 240.823"
                enableBackground="new 0 0 240.823 240.823"
              >
                <g>
                  <path
                    id="Chevron_Right"
                    d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z"
                  />
                </g>
              </svg>
            </button> */}
        </div>

        {/* <div className="second-child">
          <button
              name="scroll-right"
              className="m-0 button-shadow-right scroll"
              onClick={() => {
                this.handleManualScroll("right");
              }}
            >
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 240.823 240.823"
                enableBackground="new 0 0 240.823 240.823"
              >
                <g>
                  <path
                    id="Chevron_Right_1_"
                    d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179
                                        l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261
                                        C187.881,124.315,187.881,116.495,183.189,111.816z"
                  />
                </g>
              </svg>
            </button>
          <ul>
            <li> 120 </li>
            <li> 160 </li>
            <li> 180 </li>
          </ul>
          <button
              name="scroll-left"
              className="m-0 button-shadow-left scroll"
              onClick={() => {
                this.handleManualScroll("left");
              }}
            >
              <svg
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 240.823 240.823"
                enableBackground="new 0 0 240.823 240.823"
              >
                <g>
                  <path
                    id="Chevron_Right"
                    d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z"
                  />
                </g>
              </svg>
            </button>
        </div> */}
        <div className="last-child">
          <div className="relative">
            <button
              name="scroll-right"
              className="m-0 button-shadow-right scroll"
              onClick={() => {
                this.props.scrollHandler("right");
              }}
            >
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 240.823 240.823"
                enableBackground="new 0 0 240.823 240.823"
              >
                <g>
                  <path
                    id="Chevron_Right_1_"
                    d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179
                                        l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261
                                        C187.881,124.315,187.881,116.495,183.189,111.816z"
                  />
                </g>
              </svg>
            </button>
            <div
              style={{
                width: "650px",
                overflow: "hidden",
              }}
            >
              <ul id={"partsSlider"}>
                {this.props.activeDecorationType !== "" &&
                  this.props.decorations[this.props.activeDecorationType].map(
                    (decoration) => (
                      <li
                        key={"decorationImage" + decoration.id}
                        onClick={(evt) => {
                          evt.preventDefault();
                          this.props.selectHandler(decoration);
                        }}
                        style={{ minWidth: "100px" }}
                        className={
                          this.props.selected.indexOf(decoration.id) >= 0
                            ? "active"
                            : ""
                        }
                      >
                        {" "}
                        {decoration.image && (
                          <img src={decoration.image} alt="cover" />
                        )}{" "}
                      </li>
                    )
                  )}
                {/* {Object.keys(this.props.decorations).map((decoration) => (
                <li
                  onClick={() =>
                    this.props.selectHandler("decoration", decoration)
                  }
                  className={
                    this.props.selectedWall &&
                    this.props.selectedWall.id === decoration.id
                      ? "active"
                      : ""
                  }
                >
                  {" "}
                  {decoration.front_image && (
                    <img src={decoration.front_image} alt="cover" />
                  )}{" "}
                </li>
              ))} */}
                {/* <li>
              {" "}
              <img src="/static/b7.png" alt="cover" />{" "}
            </li>
            <li>
              {" "}
              <img src="/static/Untitled-38.png" alt="cover" />{" "}
            </li>
            <li>
              {" "}
              <img src="/static/l34.png" alt="cover" />{" "}
            </li> */}
              </ul>
            </div>
            <button
              name="scroll-left"
              className="m-0 button-shadow-left scroll"
              onClick={() => {
                this.props.scrollHandler("left");
              }}
            >
              <svg
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 240.823 240.823"
                enableBackground="new 0 0 240.823 240.823"
              >
                <g>
                  <path
                    id="Chevron_Right"
                    d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z"
                  />
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
